'use client'

import { CaseStudy } from 'enums/CaseStudy.enum'
import { useInView } from 'motion/react'
import { useEffect, useRef } from 'react'
import styles from './SocialProof.module.scss'

export type SocialProofProps = {
  caseStudy: CaseStudy
  title: string
  resultText: string
  contentText: string
  creditName: string
  creditCompany: string
}

const SocialProof = ({ caseStudy, contentText, creditName, creditCompany, resultText, title }: SocialProofProps) => {
  const targetRef = useRef<HTMLParagraphElement>(null)
  const inView = useInView(targetRef, { amount: 0.5 })

  useEffect(() => {
    if (inView) {
      targetRef.current?.classList.add(styles['in-view'])
    } else {
      targetRef.current?.classList.remove(styles['in-view'])
    }
  }, [inView])

  return (
    <section className={styles['social-proof'] + ' ' + styles[caseStudy]}>
      <div className={styles.results + ' ' + styles[caseStudy]}>
        <h2 className={styles.title + ' ' + styles[caseStudy]}>{title}</h2>
        {caseStudy === 'audubon' ? (
          <div className={styles.pixels}></div>
        ) : (
          <p ref={targetRef} className={styles.text + ' ' + styles[caseStudy]} dangerouslySetInnerHTML={{ __html: resultText }}></p>
        )}
      </div>
      <div className={styles.quote}>
        <div className={styles.portrait + ' ' + styles[caseStudy]}></div>
        <div className={styles.content}>
          <p className={styles.text + ' ' + styles[caseStudy]}>{contentText}</p>
          <span className={styles.credit + ' ' + styles[caseStudy]}>
            {creditName}
            <br />
            {creditCompany}
          </span>
        </div>
      </div>
    </section>
  )
}

export default SocialProof
